// Module
var code = "<div class=\"landing-page-steps-item\">\n    <div class=\"landing-page-steps-item__icon\" ng-transclude=\"icon\"></div>\n    <div class=\"landing-page-steps-item__desc\" ng-transclude=\"desc\"></div>\n</div>\n";
// Exports
module.exports = code;